import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as html2pdf from 'html2pdf.js';
import * as JSZip from 'jszip';
import * as moment from 'moment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { RequerimentoDTO } from 'src/app/model/dto/requerimento.dto';
import { Conta } from 'src/app/model/enum/Conta.enum';
import { Acoes } from 'src/app/model/enum/acoes.enum';
import { DocumentoService } from 'src/app/service/documento.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { DocumentoDTO } from "../../model/dto/documento.dto";
import { EditalDTO } from '../../model/dto/edital.dto';
import { DataTransferService } from '../../service/data-transfer.service';
import { RequerimentoService } from '../../service/requerimento.service';

@Component({
    selector: 'app-relacao-inscritos',
    templateUrl: './relacao-inscritos.component.html',
    styleUrls: ['./relacao-inscritos.component.css']
})
export class RelacaoInscritosComponent implements OnInit {

    documentos: DocumentoDTO[] = [];
    formInscritos: FormGroup;
    edital: EditalDTO;
    requerimentos: RequerimentoDTO[];
    requerimentosList: RequerimentoDTO[] = [];
    isZip: Boolean = false;
    requerimentoExibido: RequerimentoDTO;
    @BlockUI() blocker: NgBlockUI;
    formHtml;
    acao: Acoes;

    constructor(fb: FormBuilder,
        private router: Router,
        private dataTransfer: DataTransferService,
        private requerimentoService: RequerimentoService,
        private documentoService: DocumentoService,
        private cdr: ChangeDetectorRef,
        private location: Location
    ) {

        this.formInscritos = fb.group({
            cpfCnpj: new FormControl(''),
            cpfCnpjRequerente: new FormControl(''),
            nrPrecatorio: new FormControl(''),
            anoOrcamento: new FormControl(''),
            nome: new FormControl(''),
            dtNascimento: new FormControl(''),

            telefone: new FormControl(''),
            nrConta: new FormControl(''),
            nrAgencia: new FormControl(''),
            banco: new FormControl(''),
            tpConta: new FormControl(''),
            tipoCredito: new FormControl(''),
            tipoCredor: new FormControl(''),
            // dgAgencia:new FormControl(''),
            // dgConta:new FormControl(''),
            operacao: new FormControl(''),
            tipoChavePix: new FormControl(''),
            chavePix: new FormControl(''),
            cedido: new FormControl(''),
            credorOriginario: new FormControl(''),
            nomeCompleto: new FormControl(''),
            nomeTitular: new FormControl(''),
            redimentos: new FormControl(''),
            vinculo: new FormControl(''),
            situacao: new FormControl(''),
            orgao: new FormControl(''),
            numeroMeses: [],
            idProcessoRendimento: new FormControl(''),
            idProcessoSituacao: new FormControl(''),
            idProcessoOrgao: new FormControl(''),
            outroorgao: new FormControl(''),

        })
    }

    ngOnInit() {
        this.preencherCampos().then(() => {
            this.verificarAcao();
            this.formHtml = document.querySelector('#form') as HTMLElement;
        });
    }

    verificarAcao() {
        const { acao, requerimentos, requerimentoExibido } = this;

        if (acao === 1) {
            if (requerimentos.length === 1) {
                setTimeout(() => this.generateZipWithDocuments(requerimentoExibido), 100);
            } else if (requerimentos.length > 1) {
                this.mensagemInicial("compactados", "Baixar (ZIP)");
            }
        } else if (acao === 2) {
            this.mensagemInicial("impressos", "imprimir");
        }
    }

    mensagemInicial(acaoSeleciona: string, botaoSelecionar: string) {
        Swal.fire({
            text: `Todos os itens selecionados serão ${acaoSeleciona} na ordem selecionada. Clique no botão ${botaoSelecionar}.`,
            icon: 'info',
        });
    }

    setForm(precatorio: RequerimentoDTO, print) {
        this.edital = precatorio.edital;
        this.documentos = precatorio.documentos;

        this.formInscritos.reset({
            nrPrecatorio: precatorio.numPrecatorio,
            nome: precatorio.credor.nome,
            anoOrcamento: precatorio.anoOrcamento,
            cpfCnpj: precatorio.credor.cpfCnpj,
            cpfCnpjRequerente: precatorio.credor.cpfCnpjRequerente,
            dtNascimento: precatorio.credor.dataNascimento == null ? '' : moment(precatorio.credor.dataNascimento).format('DD/MM/YYYY').toString(),
            tipoCredito: precatorio.tipoCredito,
            telefone: precatorio.credor.contato,

            tpConta: Conta[precatorio.credor.dadosBancarios.tipoConta],
            nrAgencia: precatorio.credor.dadosBancarios.agencia,
            nrConta: precatorio.credor.dadosBancarios.numeroConta,
            tipoChavePix: precatorio.credor.dadosBancarios.tipoChavePix,
            chavePix: precatorio.credor.dadosBancarios.chavePix,
            operacao: precatorio.credor.dadosBancarios.operacao,
            banco: precatorio.credor.dadosBancarios.banco,
            tipoCredor: precatorio.credor.tipoCredor,
            // Novos campos adicionados aqui:
            cedido: precatorio.credor.cedido === 0 ? 'Sim' : 'Não',
            credorOriginario: precatorio.credor.credorOriginario === 0 ? 'Sim' : 'Não',
            nomeCompleto: precatorio.credor.nomeCompleto || null,
            nomeTitular: precatorio.credor.dadosBancarios.nomeTitular || null,
            redimentos: precatorio.redimentos === 1 ? 'Sim' : 'Não',
            vinculo: precatorio.vinculo === 0 ? 'CIVIL' : 'MILITAR',
            situacao: this.mapSituacao(precatorio.situacao),
            orgao: this.mapOrgao(precatorio.orgao), // Crie uma função para mapear
            numeroMeses: precatorio.numeroMeses || null,
            idProcessoRendimento: precatorio.idProcessoRendimento || null,
            idProcessoSituacao: precatorio.idProcessoSituacao || null,
            idProcessoOrgao: precatorio.idProcessoOrgao || null,
            outroorgao: precatorio.outroorgao || null,

        });



        this.requerimentoExibido = precatorio;

        if (print) {
            this.impressao(precatorio);
        }
        this.blocker.stop();
        if (this.cdr && !this.cdr['destroyed']) {
            this.blocker.stop();
            this.cdr.detectChanges();
        }
    }

    preencherCampos(): Promise<void> {
        return new Promise((resolve) => {
            this.dataTransfer.currentValue.subscribe((data: any) => {
                console.log('Dados recebidos pelo dataTransfer:', data);
                let precatorioList: RequerimentoDTO[] = data.requerimento;
                this.requerimentos = precatorioList;
                this.requerimentos.forEach(precatorio => this.requerimentosList.push(precatorio));

                this.setForm(precatorioList[0], false);
                this.acao = data.acao;
                resolve();
            });
        });
    }

    visualizar(documento: DocumentoDTO) {

        this.documentoService.downloadDocs(documento.key).subscribe(data => {
            const newBlob = new Blob([data], { type: "application/pdf" });
            const blobUrl = window.URL.createObjectURL(newBlob);
            window.open(blobUrl, '_blank');

        });

    }

    voltar(): void {
        this.location.back();
    }


    imprimir() {
        if (this.requerimentos.length === 0) {
            this.requerimentos = this.requerimentosList;
        }
        this.setForm(this.requerimentos[0], true)
        const requerimentos = this.requerimentos.shift();
        this.requerimentos = this.requerimentos.filter(req => req.id !== requerimentos.id);
        if (this.requerimentos.length > 0) {
            this.setForm(this.requerimentos[0], false);
            this.mensagemInicial("impressos", "imprimir");
        }
    }

    proximoRequerimento() {
        this.requerimentos = this.requerimentos.filter(req =>
            req.id !== this.requerimentoExibido.id);

        if (this.requerimentos.length > 0) {
            this.setForm(this.requerimentos[0], false);
            this.mensagemInicial("compactados", "Baixar (ZIP)");
        }
    }

    impressao(requerimento: RequerimentoDTO) {
        const keys = requerimento.documentos.map(doc => doc.key);
        Object.values(keys).forEach(hash => {
            this.documentoService.downloadDocs(hash).subscribe(data => {
                const newBlob = new Blob([data], { type: "application/pdf" });
                const iframe = document.createElement('iframe');
                const blobUrl = window.URL.createObjectURL(newBlob);
                iframe.style.display = 'none';
                iframe.src = blobUrl;
                document.body.appendChild(iframe);
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            });
        });
        window.print();
    }

    generateZipWithDocuments(requerimentoDTO: RequerimentoDTO): void {
        this.blocker.start('Baixando...');
        const zip = new JSZip();
        const keys = requerimentoDTO.documentos.map(doc => doc.key);

        const element = document.querySelector('.conteudo') as HTMLElement;
        this.isZip = true;

        // Preparar elemento HTML para geração do PDF
        this.formHtml.classList.add('no-styles', 'no-break');
        this.formHtml.style.margin = "25px";
        this.replaceInputsWithSpans();

        const pdfOptions = {
            filename: 'pagina-inicial.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 3, useCORS: true, logging: true, scrollX: 0, scrollY: 0 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        html2pdf().set(pdfOptions).from(element).outputPdf('blob')
            .then((pdfBlob: Blob) => {
                zip.file('pagina-inicial.pdf', pdfBlob);
                const docPromises = keys.map(hash => this.downloadDocument(hash, zip));

                return Promise.all(docPromises).then(() => zip.generateAsync({ type: 'blob' }));
            })
            .then(content => {
                const cpfCnpj = requerimentoDTO.credor.cpfCnpj.replace(/[-._]/g, '');
                const cpfCnpjRequerente = requerimentoDTO.credor.cpfCnpjRequerente.replace(/[-._]/g, '');
                const numeroPrecatorio = requerimentoDTO.numPrecatorio.replace(/[-._]/g, '');
                const nomeArquivo = `${numeroPrecatorio}_CPF_CNPJ_${cpfCnpj}.zip`;
                saveAs(content, nomeArquivo);
                this.renovarForm();
                this.restoreInputsFromSpans();
                this.proximoRequerimento();
            })
            .catch((error) => {
                console.error('Erro ao gerar arquivo zip:', error);
                this.renovarForm();
                alert('Erro ao gerar Zip. Por favor, tente novamente mais tarde.');
            });
    }

    replaceInputsWithSpans(): void {
        const inputs = document.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
        Array.from(inputs).forEach((input) => {
            if (!input.value) {
                const span = document.createElement('span');
                span.textContent = input.placeholder;
                span.style.color = 'rgba(0, 0, 0, 0.5)';
                span.classList.add('placeholder-span');
                if (input.parentNode) {
                    input.parentNode.insertBefore(span, input);
                }
                input.style.display = 'none';
            }
        });
    }

    restoreInputsFromSpans(): void {
        const inputs = document.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
        const spans = document.querySelectorAll('.placeholder-span');
        Array.from(spans).forEach((span) => {
            span.remove();
        });

        Array.from(inputs).forEach((input) => {
            if (!input.value) input.style.display = 'block';
        });
    }

    private downloadDocument(hash: string, zip: JSZip): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.documentoService.downloadDocs(hash).subscribe(
                (data) => {
                    const blob = new Blob([data], { type: "application/pdf" });
                    zip.file(`${hash}.pdf`, blob);
                    resolve(true);
                },
                (error) => {
                    console.error(`Erro ao baixar o documento ${hash}:`, error);
                    reject(error);
                }
            );
        });
    }

    renovarForm() {
        this.isZip = false;
        this.formHtml.classList.remove('no-styles');
        this.blocker.stop();
        this.cdr.detectChanges();
    }

    public cpfcnpjmask = function (rawValue) {
        var numbers = rawValue.match(/\d/g);
        var numberLength = 0;
        if (numbers) {
            numberLength = numbers.join('').length;
        }
        if (numberLength <= 11) {
            return [
                /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/,];
        } else {
            return [
                /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-',
                /[0-9]/, /[0-9]/,];
        }
    };

    public precatoriomask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];

    private mapSituacao(value: number): string {
        switch (value) {
            case 0: return 'ATIVO';
            case 1: return 'INATIVO';
            case 2: return 'PENSIONISTA';
            case 3: return 'Nenhum vínculo com a Administração Pública';
            default: return '';
        }
    }

    private mapOrgao(value: number): string {
        switch (value) {
            case 0: return 'Selecione...';
            case 1: return 'ALBA – Assembleia Legislativa do Estado da Bahia';
            // ... e assim por diante
            case 9: return 'Sem vínculo';
            case 10: return 'Outro';
            default: return '';
        }
    }
}


